require('vanilla-cookieconsent/dist/cookieconsent');




window.addEventListener('load', function() {

    var cookieconsent = initCookieConsent();

    // Atualiza o Google Consent Mode conforme a escolha do usuário.
    // 'marketing_cookies' cobre Google Ads/Analytics e demais tags de marketing.
    function applyConsentMode() {
        var granted = cookieconsent.allowedCategory('marketing_cookies');
        var v = granted ? 'granted' : 'denied';
        if (typeof window.gtag === 'function') {
            window.gtag('consent', 'update', {
                ad_storage: v,
                ad_user_data: v,
                ad_personalization: v,
                analytics_storage: v,
                personalization_storage: v,
                functionality_storage: v
            });
        }
        // Meta (Facebook) Pixel — carrega só quando marketing é concedido
        if (granted && typeof window.loadFacebookPixelOnConsent === 'function') {
            window.loadFacebookPixelOnConsent();
        }

        // Evento p/ gatilhar no GTM tags que NÃO obedecem o Consent Mode do Google
        // (ex.: Microsoft Clarity). Configure um trigger "Custom Event" com esse nome.
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: granted ? 'cookie_consent_marketing_granted' : 'cookie_consent_marketing_denied' });
    }

    cookieconsent.run({

        // Consent Mode: aplica no aceite e em qualquer mudança de preferências
        onAccept: function () { applyConsentMode(); },
        onChange: function () { applyConsentMode(); },

        // é true por default, determina se a mensagem de consentimento aparece sozinha

        // se passado como false, a modal só vai aparecer ao chamar a função show() da lib

        autorun: true,

        // delay para aparecer a mensagem de consentimento

        delay: 1100,

        // bloqueia a navegação na página até uma ação do usuários sobre os cookies

        force_consent: false,

        // remove automaticamente cookies das categorias que o usuário negou

        autoclear_cookies: true,

        // caso os termos ou descrição de cookies forem atualizados, incrementar esse numero

        // isso ira fazer com que a lib pergunte novamente ao usuário sobre os cookies, mesmo que já tenha aceitado anteriormente

        revision: 0,

        // determina se tags <script> de terceiros devem ser gerenciadas pela lib baseado em suas categorias definidas na tag

        // isso faz com que caso o usuário não aceite uma categorias os scripts que fazem parte dessa categoria serão desabilitados

        page_scripts: true,

        // caso o site tenha suporte a multiplos idiomas, devem ser colocadosa aqui, en é default

        languages: {

            en: {

                consent_modal: {

                    title: 'Aceitar cookies?',

                    description:

                        'Este site utiliza cookies e scripts externos para melhorar a sua experiência. Você pode aceitar todos ou escolher quais aceitar',

                    revision_message:

                        '<br> Os termos foram alterados, desculpe por incomoda-lo novamente',

                    primary_btn: {

                        text: 'Aceitar Todos',

                        role: 'accept_all', //'accept_selected' or 'accept_all'

                    },

                    secondary_btn: {

                        text: 'Configurações',

                        role: 'settings', //'settings' or 'accept_necessary'

                    },

                },

                settings_modal: {

                    title: 'Configurações avançadas de cookies',

                    save_settings_btn: 'Salvar configurações',

                    accept_all_btn: 'Aceitar todos',

                    // categorias dos cookies usados pelo site

                    blocks: [

                        {

                            title: 'Cookies essenciais',

                            description:

                                'Esses cookies permitem funcionalidades essenciais, tais como segurança, verificação de identidade e gestão de rede. Esses cookies não podem ser desativados.',

                            toggle: {

                                value: 'essentials_cookies',

                                enabled: true,

                                readonly: true,

                            },

                        },

                        {

                            title: 'Ativar cookies de marketing',

                            description:

                                'Esses cookies são usados para rastrear a eficácia da publicidade, fornecer um serviço mais relevante e anúncios melhores para atender aos seus interesses.',

                            toggle: {

                                value: 'marketing_cookies',

                                enabled: false,

                                readonly: false,

                            },

                        },

                    ],

                },

            },

        },

        // opções de layout e estilo das modais

        // cores são definidas pelas variaveis no arquivo css

        gui_options: {

            consent_modal: {

                layout: 'cloud', // box/cloud/bar

                position: 'bottom center', // bottom/top + left/right/center

                transition: 'slide', // zoom/slide

            },

            settings_modal: {

                layout: 'box', // box/bar

                // position : 'left',           // left/right

                transition: 'slide', // zoom/slide

            },

        },

    });




// ## Métodos




// exibe a mensagem de consentimento de cookies manualmente

// cookieconsent.show(<delay opicional>);

// esconde a mensagem de consentimento

// cookieconsent.hide();




// exibe a modal de preferencias de cookies

// cookieconsent.showSettings();

// esconde a modal de preferencias

// cookieconsent.hideSettings();




});